import { render, staticRenderFns } from "./PurchasingImportTax.vue?vue&type=template&id=72fe16d6&scoped=true"
import script from "./PurchasingImportTax.vue?vue&type=script&lang=js"
export * from "./PurchasingImportTax.vue?vue&type=script&lang=js"
import style0 from "./PurchasingImportTax.vue?vue&type=style&index=0&id=72fe16d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe16d6",
  null
  
)

export default component.exports